import React, {ChangeEvent} from "react";
import styled from "@emotion/styled";
import {Field} from "formik";
import {carsTheme} from "@rw/themes";

import {FilterFieldClear, InputWrap} from "./FilterFieldClear";

type Option = {value: string; label: string};

interface IClearableSelectProps {
    id: string;
    name: string;
    value: string;
    options: Option[];
    placeholder?: string;
    disabled?: boolean;
    clearLabel: string;
    /** Formik Field select vs native select */
    useFormikField?: boolean;
    onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
    onClear: () => void;
}

export const ClearableSelect: React.FC<IClearableSelectProps> = ({
    id,
    name,
    value,
    options,
    placeholder = "Wybierz",
    disabled = false,
    clearLabel,
    useFormikField = true,
    onChange,
    onClear
}) => {
    const selectedLabel = options.find((opt) => opt.value === value)?.label || value;

    if (value) {
        return (
            <InputWrap data-clearable="1">
                <SelectedValue title={selectedLabel}>{selectedLabel}</SelectedValue>
                <FilterFieldClear visible label={clearLabel} onClear={onClear} />
            </InputWrap>
        );
    }

    const selectProps = {
        id,
        name,
        value,
        disabled,
        onChange
    };

    return (
        <InputWrap>
            {useFormikField ? (
                <Select as="select" {...selectProps}>
                    <option value="">{placeholder}</option>
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </Select>
            ) : (
                <NativeSelect {...selectProps}>
                    <option value="">{placeholder}</option>
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </NativeSelect>
            )}
        </InputWrap>
    );
};

const Select = styled(Field)`
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 8px;
    font-size: 16px;
    border: 2px solid ${carsTheme.colors.gray_light};
    border-radius: 4px;
    background: #fff;
    color: ${carsTheme.colors.gray};
`;

const NativeSelect = styled.select`
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 8px;
    font-size: 16px;
    border: 2px solid ${carsTheme.colors.gray_light};
    border-radius: 4px;
    background: #fff;
    color: ${carsTheme.colors.gray};
`;

const SelectedValue = styled.div`
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: 8px 34px 8px 8px;
    font-size: 16px;
    border: 2px solid ${carsTheme.colors.gray_light};
    border-radius: 4px;
    background: #fff;
    color: ${carsTheme.colors.brand_black};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
`;
